import Constants from '~/config/Constants';

import $axios from '~/services/AxiosService';
import QLogger from '~/services/QLogger';
import ToastService from '~/services/ToastService';
import i18n from '~/services/i18n';
import Analytics from '~/services/EventLoggerService';
import ReportsEventsList from '~/config/ReportEventsList';

const OLD_REPORT_QUERY_KEY = 'useOldReport';

export default class MigratedReportsAPIService {
  static async fetchGame(gameId) {
    try {
      const result = await $axios().get(`v2/game/${gameId}/game-info`);
      const aggVersion = result?.data?.data.gameInfo.aggVersion;
      if (!aggVersion || aggVersion === '0.0.0') {
        const currentUrl = window.location.href;
        if (!currentUrl.includes(OLD_REPORT_QUERY_KEY)) {
          const newQuery = currentUrl.includes('?') ? `&${OLD_REPORT_QUERY_KEY}=true` : `?${OLD_REPORT_QUERY_KEY}=true`;
          window.location.href = currentUrl + newQuery;
          Analytics.logEvent(ReportsEventsList.isOldReport, { gameId, isOld: true });
        }
      }
      return result?.data;
    } catch (err) {
      QLogger.log('Error at MigratedReportsAPIService.fetchGame', err);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n('Something went wrong while fetching report details'),
      });
      throw err;
    }
  }

  static async fetchQuestions(args) {
    let filterString = '';

    if (args.questionIds && Array.isArray(args.questionIds)) {
      filterString = `?qId=${encodeURIComponent(JSON.stringify(args.questionIds))}`;
    }

    try {
      const result = await $axios().get(`v2/game/${args.gameId}/questions${filterString}`);
      return result?.data;
    } catch (e) {
      QLogger.log('Error at MigratedReportsAPIService.fetchQuestions', e);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n('Something went wrong while fetching questions details!'),
      });
      throw e;
    }
  }

  static async fetchResponses(args) {
    try {
      const filterString = `qId=${encodeURIComponent(JSON.stringify(args.questionIds || []))}&pId=${encodeURIComponent(JSON.stringify(args.playerIds || []))}`;
      const result = await $axios().get(`v2/game/${args.gameId}/responses?${filterString}`);
      return result?.data;
    } catch (e) {
      QLogger.log('Error at MigratedReportsAPIService.fetchResponses', e);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n('Something went wrong while fetching responses!'),
      });
      throw e;
    }
  }

  static async fetchStandards(gameId) {
    try {
      const result = await $axios().get(`v2/game/${gameId}/standards`);
      return result.data;
    } catch (e) {
      QLogger.log('Error at MigratedReportsAPIService.fetchStandards', e);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n('Something went wrong while fetching topic details!'),
      });
      throw e;
    }
  }

  static async fetchAIGeneratedReport(gameId) {
    try {
      const result = await $axios().get(`analyze-game/${gameId}`);
      return result.data.data;
    } catch (e) {
      QLogger.log('Error at MigratedReportsAPIService.fetchAIGeneratedReport', e);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n('Something went wrong while analyzing report details!'),
      });
      throw e;
    }
  }

  static async generateAIReport(gameId) {
    try {
      const result = await $axios().post(`analyze-game/${gameId}`);
      return result.data.data;
    } catch (e) {
      QLogger.log('Error at MigratedReportsAPIService.generateAIReport', e);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n('Something went wrong while fetching topic details!'),
      });
      throw e;
    }
  }

  static async tagGameToTopic({ gameId, assignedGameId, topicId }) {
    try {
      const result = await $axios().post(`analyze-game/${gameId}/assign`, {
        topicId,
        assignedGameId,
      });
      return result.data.data;
    } catch (e) {
      QLogger.log('Error at MigratedReportsAPIService.tagGameToTopic', e);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n('Something went wrong while fetching topic details!'),
      });
      throw e;
    }
  }

  static async gclNudge(payload) {
    try {
      await $axios().post('/groups/announce-individual', payload);
    } catch (e) {
      QLogger.log('Error at MigratedReportsAPIService.gclNudge', e);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n('Something went wrong while sending nudge'),
      });
      throw e;
    }
  }

  static async fetchEmailIds(gameId, isCorporate) {
    try {
      const response = await $axios().get(`/emails/fetch?gameId=${gameId}`);
      return response.data.data;
    } catch (e) {
      QLogger.log('Error at MigratedReportsAPIService.fetchEmailIds', e);
      ToastService.add({
        type: Constants.ToastTypes.ERROR,
        icon: 'fas fa-times-circle',
        title: i18n(`Something went wrong while fetching ${isCorporate ? 'participants' : 'parents'} email ids`),
      });
    }
  }
}
